import { memo } from "react";
import "./Searchbar.scss";
import { IconSearch } from "app/pages/.shared/static/icons";
import classNames from "classnames";

const Searchbar = ({ className, ...props }) => {
	const searchbarClassName = classNames("searchbar-input", className);

	return (
		<div className={searchbarClassName}>
			<IconSearch width={20} className="searchbar-input__icon" />
			<input type="text" {...props} />
		</div>
	);
};

export default memo(Searchbar);
